import CommonUtil from "../utils/CommonUtil";
import { queries } from "./queries";
import { parts, urls, URL_SEPARATOR } from "./urls";

class UrlFactory {
  _constructUrlQuery(...urlQueries) {
    var url = "";

    if (urlQueries[0] !== undefined && urlQueries[0] !== null) {
      urlQueries[0].forEach(query => {
        if (
          query.value !== undefined &&
          query.value !== null &&
          query.value !== ""
        ) {
          if (url.length > 0) {
            url += queries.QUERY_SEPARATOR;
          }
          url += query.name + queries.QUERY_NAME_VALUE_SEPARATOR + query.value;
        }
      });
    }

    return url;
  }

  _constructUrlQueries(urlQueries) {
    var url = this._constructUrlQuery(urlQueries);

    if (url.length > 0) {
      url = queries.QUERY_START + url;
    }

    return url;
  }

  _constructPaginationQuery(pageInfo) {
    if (pageInfo === undefined) return undefined;

    const urlQueries = [
      { name: queries.PAGE_QUERY, value: pageInfo.number },
      { name: queries.SIZE_QUERY, value: pageInfo.size }
    ];

    if (pageInfo.offset) {
      urlQueries.push({ name: queries.OFFSET_QUERY, value: pageInfo.offset });
    }

    return this._constructUrlQuery(urlQueries);
  }

  _constructSortQuery(sortInfo) {
    if (!sortInfo) return undefined;

    if (!Array.isArray(sortInfo)) {
      sortInfo = [sortInfo];
    }

    const urlQueries = sortInfo
      .filter(item => item.orderBy)
      .map(item => {
        return {
          name: queries.SORT,
          value: item.orderBy + "," + item.direction
        };
      });

    return this._constructUrlQuery(urlQueries);
  }

  constructPasswordRequirementsQuery(authenticationType) {
    const urlQueries = [
      { name: queries.AUTHENTICATION_TYPE_QUERY, value: authenticationType }
    ];

    return this._constructUrlQueries(urlQueries);
  }

  constructCheckEmailQuery(authenticationType, email) {
    const urlQueries = [
      { name: queries.AUTHENTICATION_TYPE_QUERY, value: authenticationType },
      { name: queries.EMAIL_QUERY, value: email }
    ];

    return this._constructUrlQueries(urlQueries);
  }

  _constructFilteringQuery(filters) {
    var urlQueries = [];

    if (filters !== null && filters !== undefined) {
      Object.keys(filters).forEach(function (key) {
        const filter = filters[key];
        var comparator = undefined;
        var value = undefined;
        switch (filter.filterType) {
          case "TEXT":
            switch (filter.comparator) {
              case "LIKE":
                comparator = "like";
                break;
              case "=":
                comparator = "eq";
                break;
              default:
                break;
            }
            value = filter.filterVal;
            break;
          case "BOOLEAN": {
            value = filter.filterVal;
            break;
          }
          case "NUMBER":
            switch (filter.filterVal.comparator) {
              case "=":
                comparator = "eq";
                break;
              case "!=":
                comparator = "neq";
                break;
              case ">":
                comparator = "gt";
                break;
              case ">=":
                comparator = "gte";
                break;
              case "<":
                comparator = "lt";
                break;
              case "<=":
                comparator = "lte";
                break;
              default:
                break;
            }
            value = filter.filterVal.number;
            break;
          case "SELECT": {
            switch (filter.comparator) {
              case "=":
                comparator = "eq";
                break;
              case "IN":
                comparator = "in";
                break;
              case "NOTIN":
                comparator = "nin";
                break;
              default:
                break;
            }
            if (Array.isArray(filter.filterVal)) {
              value = filter.filterVal.join();
            } else {
              value = filter.filterVal;
            }
            break;
          }
          default:
            break;
        }
        if (comparator !== undefined && value !== undefined && value !== "") {
          urlQueries.push({
            name: key,
            value:
              comparator + queries.FILTERING_COMPARATOR_SEPARATOR_QUERY + value
          });
        }
        if (!comparator && value && value !== "") {
          urlQueries.push({
            name: key,
            value: value
          });
        }
      });
    }

    return this._constructUrlQuery(urlQueries);
  }

  constructPaginationAndFilteringUrlQueries(
    pageInfo,
    sortInfo,
    alreadyContainsUrlParams = false
  ) {
    var urlQueries = "";
    var filters = null;
    if (pageInfo) {
      filters = pageInfo.filters;
    }

    const paginationQuery = this._constructPaginationQuery(pageInfo);
    const sortQuery = this._constructSortQuery(sortInfo);
    const filteringQuery = this._constructFilteringQuery(filters);

    const query_start = alreadyContainsUrlParams
      ? queries.QUERY_SEPARATOR
      : queries.QUERY_START;

    if (paginationQuery && paginationQuery.length > 0) {
      urlQueries += query_start + paginationQuery;
      if (sortQuery && sortQuery.length > 0) {
        urlQueries += queries.QUERY_SEPARATOR + sortQuery;
      }
      if (filteringQuery && filteringQuery.length > 0) {
        urlQueries += queries.QUERY_SEPARATOR + filteringQuery;
      }
    } else if (filteringQuery && filteringQuery.length > 0) {
      urlQueries += query_start + filteringQuery;
      if (sortQuery && sortQuery.length > 0) {
        urlQueries += queries.QUERY_SEPARATOR + sortQuery;
      }
    } else if (sortQuery && sortQuery.length > 0) {
      urlQueries += query_start + sortQuery;
    }

    return urlQueries;
  }

  checkUrlContainsParams(url) {
    const indexOfQueryStart = url.indexOf(queries.QUERY_START);
    if (indexOfQueryStart && indexOfQueryStart !== -1) {
      const params = url.substring(indexOfQueryStart);
      if (params && params.length > 0) {
        return true;
      }
    }
    return false;
  }

  itemUrl(collectionUrl, id) {
    return collectionUrl + URL_SEPARATOR + id;
  }
  joinUrl(...parts) {
    return CommonUtil.concatStringsWithDelimiter(URL_SEPARATOR, ...parts);
  }
  currentPartyUrl() {
    return urls.CURRENT_PARTY_URL;
  }
  systemProcessesUrl() {
    return urls.SYSTEM_PROCESSES_URL;
  }
  classificationTypesUrl() {
    return urls.CLASSIFICATION_TYPES_URL;
  }
  classificationStatusesUrl() {
    return urls.CLASSIFICATION_STATUSES_URL;
  }
  classificationsUrl() {
    return urls.CLASSIFICATIONS_URL;
  }
  classificationUrl(classificationId) {
    return this.itemUrl(this.classificationsUrl(), classificationId);
  }
  entitiesUrl() {
    return urls.ENTITIES_URL;
  }
  knowledgeItemsUrl() {
    return urls.KNOWLEDGES_URL;
  }
  knowledgeItemUrl(knowledgeItemId) {
    return this.itemUrl(this.knowledgeItemsUrl(), knowledgeItemId);
  }
  knowledgeTypesUrl() {
    return urls.KNOWLEDGE_TYPES_URL;
  }
  knowledgeCopyrightsUrl() {
    return urls.KNOWLEDGE_COPYRIGHTS_URL;
  }
  knowledgeSourcesUrl() {
    return urls.KNOWLEDGE_SOURCES_URL;
  }
  knowledgeSourceClassificationsUrl() {
    return urls.KNOWLEDGE_SOURCE_CLASSIFICATIONS_URL;
  }
  lifeCyclesUrl() {
    return urls.LIFE_CYCLES_URL;
  }
  lifeCycleUrl(lifeCycleId) {
    return this.itemUrl(this.lifeCyclesUrl(), lifeCycleId);
  }
  documentsUrl() {
    return urls.DOCUMENTS_URL;
  }
  entityRatingsUrl() {
    return urls.ENTITY_RATINGS_URL;
  }
  entityMessageLogsUrl() {
    return urls.ENTITY_MESSAGE_LOGS_URL;
  }
  entityMessageLogTypesUrl() {
    return urls.ENTITY_MESSAGE_LOG_TYPES_URL;
  }
  lifeCycleStateTypeUrl(lifeCycleStateTypeId) {
    return this.itemUrl(this.lifeCycleStateTypesUrl(), lifeCycleStateTypeId);
  }
  lifeCycleStateTypesUrl() {
    return urls.LIFE_CYCLE_STATE_TYPES_URL;
  }
  lifeCycleClassDefinitionUrl(lifeCycleClassDefinitionId) {
    return this.itemUrl(
      this.lifeCycleClassDefinitionsUrl(),
      lifeCycleClassDefinitionId
    );
  }
  lifeCycleClassDefinitionsUrl() {
    return urls.LIFE_CYCLE_CLASS_DEFINITIONS_URL;
  }
  lifeCycleHistoryLogsUrl() {
    return urls.LIFE_CYCLE_HISTORY_LOGS_URL;
  }
  involvementRolesUrl() {
    return urls.INVOLVEMENT_ROLES_URL;
  }
  involvementRoleTypesUrl() {
    return urls.INVOLVEMENT_ROLE_TYPES_URL;
  }
  partyRolesUrl() {
    return urls.PARTY_ROLES_URL;
  }
  partyRoleTypesUrl() {
    return urls.PARTY_ROLES_TYPES_URL;
  }
  partyRoleTypeDiscriminatorsUrl() {
    return urls.PARTY_ROLE_TYPE_DISCRIMINATORS_URL;
  }
  extensionsUrl() {
    return urls.EXTENSIONS_URL;
  }
  partyClassificationsByOperationUrl(partyId) {
    return this.itemUrl(urls.PARTY_CLASSIFICATIONS_BY_OPERATION_URL, partyId);
  }
  operationsUrl() {
    return urls.OPERATIONS_URL;
  }
  languagesUrl() {
    return urls.LANGUAGES_URL;
  }
  partiesUrl() {
    return urls.PARTIES_URL;
  }
  partyUrl(partyId) {
    return this.itemUrl(this.partiesUrl(), partyId);
  }
  individualsUrl() {
    return urls.INDIVIDUALS_URL;
  }
  tagsUrl() {
    return urls.TAGS_URL;
  }
  elasticSearchUrl() {
    return urls.ELASTIC_SEARCH_URL;
  }
  partySubscriptionsUrl() {
    return urls.PARTY_SUBSCRIPTIONS_URL;
  }
  partyMessagesUrl() {
    return urls.PARTY_MESSAGES_URL;
  }
  partyMessageUrl(messageId) {
    return this.itemUrl(this.partyMessagesUrl(), messageId);
  }
  readPartyMessageUrl(messageId) {
    return this.joinUrl(this.partyMessageUrl(messageId), parts.READ);
  }
  entityRelationshipTypeUrl() {
    return urls.ENTITY_RELATIONSHIP_TYPES_URL;
  }
  relationCardinalityTypeUrl() {
    return urls.RELATION_CARDINALITY_TYPES_URL;
  }
  tagsOccurenceUrl() {
    return this.joinUrl(this.tagsUrl(), parts.OCCURRENCES);
  }
  classificationsOccurenceUrl() {
    return this.joinUrl(this.classificationsUrl(), parts.OCCURRENCES);
  }
  elasticSearchReindexStatusUrl() {
    return this.joinUrl(this.elasticSearchReindexUrl(), parts.STATUS);
  }
  elasticSearchReindexUrl() {
    return urls.ELASTIC_SEARCH_REINDEX_URL;
  }
  entityRelationshipsUrl() {
    return urls.ENTITY_RELATIONSHIPS_URL;
  }
  websocketUrl() {
    return urls.WEBSOCKET_URL;
  }
  collectionCompactViewUrl(collectionUrl) {
    return this.joinUrl(collectionUrl, parts.COMPACT_VIEW);
  }
  elasticSearchReindexEntityUrl(entityId) {
    return this.itemUrl(this.elasticSearchReindexUrl(), entityId);
  }
  elasticSearchReindexEntityStatusUrl(entityId) {
    return this.joinUrl(
      this.elasticSearchReindexEntityUrl(entityId),
      parts.STATUS
    );
  }
  searchSimilarKnowledgeItems() {
    return this.joinUrl(this.knowledgeItemsUrl(), parts.SEARCH_SIMILAR);
  }
  searchKnowledgeItems() {
    return this.joinUrl(this.knowledgeItemsUrl(), parts.SEARCH);
  }

  entityTopViewOccurenceUrl() {
    return this.joinUrl(this.knowledgeItemsUrl(), parts.OCCURRENCES);
  }

  recommendedKnowledgeItems() {
    return this.joinUrl(this.knowledgeItemsUrl(), parts.RECOMMENDED);
  }
  organisationsUrl() {
    return urls.ORGANISATIONS_URL;
  }
}

export default UrlFactory;
